import "./pie.css";

import { createStyles, makeStyles } from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";

import { PiePieceData } from ".";
import { RelodeTheme } from "./../styles";
import { Pie } from "./pie";
import { PieLegend } from "./pieLegend";

const useStyles = makeStyles((theme: RelodeTheme) =>
    createStyles({
        root: {},
        pie: {},
        legend: {
            marginLeft: theme.spacing(2),
        },
    })
);

interface PieChartProps {
    data: PiePieceData[];
    thickness: number;
    offset?: number;
    diameter: number;
    onClick: (data: PiePieceData) => void;
    centerElement?: React.ReactNode;
    animate?: boolean;
    format?: (data: PiePieceData, index: number) => string;
    className?: string;
    legendWidth: number;
}

export const PieChart = (props: PieChartProps) => {
    const {
        offset = 0.5,
        diameter,
        thickness,
        data,
        onClick,
        format,
        animate,
        centerElement,
        className,
        legendWidth,
    } = props;
    const classes = useStyles(props);
    const offsetNum = thickness * offset;
    const outerRadius = diameter / 2;
    const innerRadius = Math.max(outerRadius - thickness - offsetNum, 0);

    // NOTE: style is used here for two reasons:
    // 1. it is highly dynamic (width, height) and prefer this method over using props in the styles object above.
    // 2. to ensure that certain styling is not overridden by the containing component.
    return (
        <div className={classnames(classes.root, className)}>
            <Pie
                animate={animate}
                centerElement={centerElement}
                className={classes.pie}
                data={data}
                innerRadius={innerRadius}
                offset={offsetNum}
                onClick={onClick}
                outerRadius={outerRadius}
            />
            <PieLegend
                animate={animate}
                className={classes.legend}
                data={data}
                innerRadius={innerRadius}
                offset={offsetNum}
                onClick={onClick}
                outerRadius={outerRadius}
                width={legendWidth}
            />
        </div>
    );
};
